export const routes = [
    {
        name: 'nps.admin.main.menu.dashboard.label',
        sectionHeading: 'nps.admin.main.menu.dashboard.sectionHeading',
        path: 'nps/dashboard',
    },
    {
        name: 'nps.admin.main.menu.new.survey.label',
        sectionHeading: 'nps.admin.main.menu.new.survey.sectionHeading',
        path: 'nps/new-survey',
    },

    {
        name: 'nps.admin.main.menu.history.label',
        sectionHeading: 'nps.admin.main.menu.history.sectionHeading',
        path: 'nps/history',
    },
]

export const surveyTabsCa = [
    {
        name: 'nps.admin.translations.menu.en',
        translationType: 'English translation',
    },
    {
        name: 'nps.admin.translations.menu.fr',
        translationType: 'French translation',
    },
]

export const surveyTabsBr = [
    {
        name: 'nps.admin.translations.menu.en',
        translationType: 'English translation',
    },
    {
        name: 'nps.admin.translations.menu.pt',
        translationType: 'Portuguese translation',
    },
]
